import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import { useAuth } from './AuthContext';

const ProtectedLayout: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  
  // Only render protected routes if authenticated and not on login-related paths
  const isLoginRoute = location.pathname === '/login' || 
                      location.pathname === '/login/callback' || 
                      location.pathname === '/not-authorized';
  
  if (!isAuthenticated || isLoginRoute) {
    return null;
  }
  
  return (
    <ProtectedRoute>
      <Outlet />
    </ProtectedRoute>
  );
};

export default ProtectedLayout; 